<jw-modal id='setWeightModal'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <h1 class='header'>Set Weight</h1>
  <hr />

  <div class='row'>
    <div class='col-md-8'>
      @if (this.job.jobAssignment !== undefined) {
        <div class='form-row'>
          @if (this.job.order.orderTypeId === 1) {
            <div class="form-group col-md-4">
              <label for="inputEmail4">Grade</label>
              <select class='form-control' [class.is-invalid]='this.job.order.gradeId === -1'
                (change)='this.job.order.gradeId = +$event.target.value; this.job.order.grade.id = this.job.order.gradeId;'>
                <option value='-1'>Select a grade</option>
                @for (item of this.grades; track item) {
                  <option [value]='item.id'
                  [selected]='this.job.order.gradeId === item.id'>{{ item.name }}({{ item.ewcCodes }})</option>
                }
              </select>
            </div>
          }
        </div>
        <div class='form-row'>
          <div class='form-group col-md-4'>
            <label>Gross Weight</label>
            <input [class.is-invalid]='!this.job.weight' (keyup)='this.findAndSetPriceListOverweightCharge()'
              type='text' class='form-control' [(ngModel)]='this.job.weight' />
          </div>
        </div>
        <div class='form-row'>
          <div class='form-group col-md-4'>
            <label>Tare Weight</label>
            <input type='text' class='form-control' [(ngModel)]='this.job.tareWeight' />
          </div>
        </div>
        <div class='form-row'>
          <label>Net Weight</label>
          @if (this.job.jobAssignment.vehicleId !== -1) {
            <div class='form-group col-md-4'>
              <input type='text' class='form-control' [value]='(this.job.weight - this.job.tareWeight).toFixed(2)'
                readonly />
            </div>
          }
        </div>
      }
    </div>



    <div class='col-md-4'>
      <h2 class='header'>Order items</h2>

      @if (this.orderLines.length > 0) {
        <table class="table">
          <thead>
            <th>Name</th>
            <th>Qty</th>
            <th>Unit</th>
            <th>Base Price(&pound;)</th>
            <th>Total Price(&pound;)</th>
            <th></th>
          </thead>
          <tbody>
            @for (item of this.orderLines; track item) {
              <tr>
                <td>{{ item.quoteLine ? item.quoteLine.product.name : item.name }}</td>
                <td>
                  <input type="number" min='0' name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.qty'
                    [readOnly]='item.isPrimaryCharge'>
                </td>
                <td>
                  {{ item.quoteLine ? getUnitFromId(item.quoteLine.product.unitId) : getUnitFromId(item.unitId) }}(s)
                </td>
                <td>
                  <input type="number" min='0' name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.price'>
                </td>
                <td>
                  {{ getTotalPriceForOrderLine(item).toFixed(2) }}
                </td>
                <td>
                  <input type='checkbox' [(ngModel)]="item.isPrimaryCharge" [ngModelOptions]="{standalone: true}" />&nbsp;
                  Is Primary Charge?
                </td>
              </tr>
            }
          </tbody>
        </table>
      }

      <div>
        <label>Overweight Notes</label>
        <textarea class='form-control' [(ngModel)]="this.job.complianceNotes"></textarea>
      </div>
    </div>
  </div>
  <button class='btn btn-success' (click)='save()'>Save</button>&nbsp;
  <button class='btn btn-danger' (click)='close()'>Cancel</button>

</jw-modal>